import React, { createContext } from 'react';

export const AlertContext = createContext();


